import React, { Component } from 'react';
import _ from 'lodash';
import Rating from 'react-rating';
import {Control, Form} from "react-redux-form";

export default class Surveys extends Component {
	render(){
		const { reports } = this.props;
		const { surveys } = reports;
		let sc = _.find(reports.permissions, (o) => {return o==='Create'}) ? true:false;
		return (
			<div className="columns is-centered">
				<div className="column">
					<Form model="reports.surveys.data" onSubmit={(values) => this._submitForm(values)}>
						<h1 className="title is-1">{surveys.data.name}</h1>
						{/* <p className="has-text-inm-purple">La escala de calificación de la encuesta de satisfacción es de 1 a 5, donde <u><b>1</b> representa la evaluación más <b>baja</b> y <b>5</b> la más <b>alta</b>.</u></p> */}
						<table className="inm-table">
							<tbody>
								{_.map(surveys.data.children_questions, (item, key) => {
									if(item.type==='group'){
										if(item.name!=="-"){
											return [
												<tr key={`group-${key}`}>
													<td colSpan={2} className="has-text-left">
														<strong>{`${key+1}. ${item.name}`}</strong>
													</td>
												</tr>,
												_.map(item.children_questions,(row,k) => {
													return <RowQuestion key={k} model={`reports.surveys.data.children_questions[${key}].children_questions[${k}].answer${row.type === 'rating' ? '.answer_number':'.answer_text'}`} groupIndex={key} questionIndex={k} row={row} {...this.props}/>
												})
											]
										}
									}else {
										return <RowQuestion key={key} number={key+1} model={`reports.surveys.data.children_questions[${key}].answer${item.type === 'rating' ? '.answer_number':'.answer_text'}`} groupIndex={key} questionIndex={undefined} row={item} {...this.props}/>
									}
								})}
							</tbody>
						</table>
						<br/>
						<div className="field is-grouped is-grouped-right">
							<div className="control">
								<button className="button is-large" onClick={() => this.props.history.goBack()}>
									Regresar
								</button>
							</div>

							{sc ?
							<div className="control">
								<Control.button model="reports.surveys.data" className="button is-large is-primary" disabled={surveys.data.editable ? false:true}>Guardar</Control.button>
							</div>
							:''}

						</div>
					</Form>
				</div>
			</div>
		)
	}

	_submitForm(values){
		let { modality, state, municipality } = this.props.match.params;
		this.props.reportsSurveySave(values, modality, state, municipality);
	}

}

class RowQuestion extends Component {
	render(){
		let { row, model, groupIndex, questionIndex, reports} = this.props
		let { surveys } = reports; let answer = undefined;
		let initialValue = undefined;
		if(questionIndex !== undefined ){
			answer = surveys.data.children_questions[groupIndex].children_questions[questionIndex].answer
			initialValue = answer ? answer.answer_number:0;
		}else {
			answer = surveys.data.children_questions[groupIndex].answer
			initialValue = answer ? answer.answer_number:0;
		}
		return(
			<tr>
				<td style={{width: 70 + '%'}} className="has-text-left">
					{this.props.number ?
						<strong>{`${this.props.number}. ${row.name}`}</strong>:
						<p>{row.name}</p>
					}
				</td>
				<td>
					{row.type === 'rating' ?
						<Control model={model} id={`question-${row.id}`} ref={`question-${row.id}`} component={Rating}
						         start={0} stop={5} step={1}
						         initialRating={initialValue}
						         emptySymbol="fa fa-square-o fa-2x"
						         fullSymbol="fa fa-check-square-o fa-2x"
						         className="has-text-inm-purple"/>
						:<Control.textarea model={model} className="textarea" id={`question-${row.id}`} ref={`question-${row.id}`} />}
				</td>
			</tr>
		)
	}
}


// WEBPACK FOOTER //
// ./src/elements/reports/surveys.jsx